import { default as websocketLogger } from '@providers/MytaverseProvider/logger';
import {
  createSessionSkipLog,
  describeSkipDecision,
} from './sessionMessageSkipLog';

// The one instance every dashboard websocket handler shares, so the dozen handlers that skip the SAME message
// produce one line between them rather than a dozen. Replaces the per-site `mytaverseLogger.debug('Skip handle WS
// message …')` — the filtering at the call site is unchanged, only its narration is.
const skipLog = createSessionSkipLog();

export const logSkippedSessionMessage = (
  sessionKey: string,
  expectedSessionKey: string,
): void => {
  const line = describeSkipDecision(
    skipLog.note(sessionKey, expectedSessionKey, Date.now()),
  );

  if (line) {
    websocketLogger.debug(line);
  }
};
